import { FunctionComponent } from "react";
import { Mep, SocialNetwork } from "../../service/data";
import {Box, makeStyles,Button,Tooltip} from "@material-ui/core";

import { useTranslate } from "../../service/translation";
import { getSocialIcon } from "./socialUtils";

interface SocialLinksProps {
    record: Mep,
}

/**
 * The buttons on a contributor's page, in this order. `record.socialNetworks` is keyed by feeder
 * type, one entry per type the contributor has a feeder for, so a type shows when there is one.
 * Only twitter, bluesky and instagram are polled; the rest are links and nothing more (ops issues/061,
 * 018).
 */
const LINKS: SocialNetwork[] = [
    "website",
    "twitter",
    "bluesky",
    "facebook",
    "instagram",
    "threads",
    "tiktok",
    "youtube",
    "linkedin",
    "rss",
];

const useStyles = makeStyles(theme => ({
    links: {
        display: "flex",
        justifyContent: "center",
        margin: theme.spacing(6, 0),
        "& > a":{
            boxShadow: "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
            margin: theme.spacing(0, 0.5),
            height: theme.spacing(4),
            width: theme.spacing(4),
            minWidth: "0px !important",
            backgroundColor: theme.palette.type === "light" ? "white" : "#333",
            "&:hover": {
                boxShadow: "0px 2px 4px -1px rgb(0 0 0 / 20%), 0px 4px 5px 0px rgb(0 0 0 / 14%), 0px 1px 10px 0px rgb(0 0 0 / 12%)",
            },
            "& .MuiSvgIcon-root": {
                height: theme.spacing(2.5),
                width: theme.spacing(2.5),
            },
        },
    },
}));

const SocialLinks: FunctionComponent<SocialLinksProps> = (props: SocialLinksProps) => {
    const classes = useStyles();
    const { record: { socialNetworks }} = props;
    const translate = useTranslate();

    return (
        <Box className={classes.links + " socialMediaIcons"}>
            {LINKS.filter(network => socialNetworks?.[network]?.url).map(network => {
                const label = translate("newshub.action." + network);
                return (
                    <Tooltip key={network} title={label}>
                        <Button
                            href={socialNetworks[network].url}
                            target="_blank"
                            aria-label={label}
                            color="primary"
                            size="small"
                            rel="noopener noreferrer"
                        >
                            {getSocialIcon(network)}
                        </Button>
                    </Tooltip>
                );
            })}
        </Box>
    );
};

export default SocialLinks;
